import { intl } from '@trello/i18n';

// eslint-disable-next-line @trello/less-matches-component
import styles from './CarouselCard.less';

// Will update images with final SVG files once provided by design
// eslint-disable-next-line @trello/assets-alongside-implementation
import boardImage from 'resources/images/split-screen-onboarding/board-card-image.png';
// eslint-disable-next-line @trello/assets-alongside-implementation
import inboxImage from 'resources/images/split-screen-onboarding/inbox-card-image.png';
// eslint-disable-next-line @trello/assets-alongside-implementation
import plannerImage from 'resources/images/split-screen-onboarding/planner-card-image.png';

export const carouselCardContent = {
  inbox: {
    title: intl.formatMessage({
      id: 'templates.split_screen.inbox',
      defaultMessage: 'Inbox',
      description: 'Inbox card title',
    }),
    body: intl.formatMessage({
      id: 'templates.split_screen.onboarding.carousel-screen.inbox-body',
      defaultMessage: 'Capture everything, wherever you are.',
      description: 'Inbox card body',
    }),
    image: inboxImage,
    className: styles.inboxCard,
  },
  planner: {
    title: intl.formatMessage({
      id: 'templates.split_screen.planner',
      defaultMessage: 'Planner',
      description: 'Planner card title',
    }),
    body: intl.formatMessage({
      id: 'templates.split_screen.onboarding.carousel-screen.planner-body',
      defaultMessage: 'Schedule time for your most important tasks.',
      description: 'Planner card body',
    }),
    image: plannerImage,
    className: styles.plannerCard,
  },
  board: {
    title: intl.formatMessage({
      id: 'templates.split_screen.board',
      defaultMessage: 'Board',
      description: 'Board card title',
    }),
    body: intl.formatMessage({
      id: 'templates.split_screen.onboarding.carousel-screen.board-body',
      defaultMessage: 'Get it organized, then get it done.',
      description: 'Board card body',
    }),
    image: boardImage,
    className: styles.boardCard,
  },
};
